export const SCHEMA_GRAZZINI_AXES = [
  {
    key: 'corporeoOggettuale',
    label: 'Corporeo\noggettuale',
    area: 'motoria',
  },
  {
    key: 'destrezzaImpegnoFisico',
    label: 'Destrezza\nfisica',
    area: 'motoria',
  },
  {
    key: 'ambiente',
    label: 'Ambiente',
    area: 'motoria',
  },
  {
    key: 'alleanzaOpposizione',
    label: 'Alleanza /\nopposizione',
    area: 'relazionale',
  },
  {
    key: 'opposizioneDirettaIndiretta',
    label: 'Opposizione',
    area: 'relazionale',
  },
  {
    key: 'ambivalenzaRuoli',
    label: 'Ambivalenza\nruoli',
    area: 'relazionale',
  },
  {
    key: 'capacitaDiRuoli',
    label: 'Ruoli',
    area: 'relazionale',
  },
  {
    key: 'atteggiamentiLinguaggioPensiero',
    label: 'Linguaggio /\npensiero',
    area: 'cognitiva',
  },
  {
    key: 'tatticaIndividuale',
    label: 'Tattica\nindividuale',
    area: 'cognitiva',
  },
  {
    key: 'strategiaCollettiva',
    label: 'Strategia\ncollettiva',
    area: 'cognitiva',
  },
  {
    key: 'memoria',
    label: 'Memoria',
    area: 'cognitiva',
  },
  {
    key: 'aspettiMusicali',
    label: 'Aspetti\nmusicali',
    area: 'cognitiva',
  },
  {
    key: 'percezioneSpazioTempo',
    label: 'Spazio /\ntempo',
    area: 'cognitiva',
  },
];

export const SCHEMA_GRAZZINI_AREAS = {
  motoria: 'AREA MOTORIA',
  relazionale: 'AREA RELAZIONALE',
  cognitiva: 'AREA COGNITIVO-ESPRESSIVA',
};

export const SCHEMA_GRAZZINI_SCALE_LINES = [
  '0 = assente',
  '1 = molto basso',
  '2 = basso',
  '3 = medio',
  '4 = alto',
  '5 = dominante nel gioco',
];

export const DEFAULT_SCHEMA_GRAZZINI = {
  enabled: false,
  values: {
    corporeoOggettuale: 0,
    destrezzaImpegnoFisico: 0,
    ambiente: 0,
    alleanzaOpposizione: 0,
    opposizioneDirettaIndiretta: 0,
    ambivalenzaRuoli: 0,
    capacitaDiRuoli: 0,
    atteggiamentiLinguaggioPensiero: 0,
    tatticaIndividuale: 0,
    strategiaCollettiva: 0,
    memoria: 0,
    aspettiMusicali: 0,
    percezioneSpazioTempo: 0,
  },
  notes: '',
};

function clampInt0to5(n) {
  const x = Math.round(Number(n));
  if (!Number.isFinite(x)) return 0;
  return Math.max(0, Math.min(5, x));
}

/** Accetta oggetto o stringa JSON da Strapi/API. */
export function parseSchemaGrazziniRaw(raw) {
  if (raw == null) return null;
  if (typeof raw === 'string') {
    const t = raw.trim();
    if (!t) return null;
    try {
      const parsed = JSON.parse(t);
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        return parsed;
      }
    } catch {
      return null;
    }
    return null;
  }
  if (typeof raw === 'object' && !Array.isArray(raw)) return raw;
  return null;
}

/** Normalizza payload API / stato. */
export function mergeSchemaGrazzini(raw) {
  const base = {
    ...DEFAULT_SCHEMA_GRAZZINI,
    values: { ...DEFAULT_SCHEMA_GRAZZINI.values },
  };
  const data = parseSchemaGrazziniRaw(raw);
  if (!data) return base;
  const values = { ...base.values };
  SCHEMA_GRAZZINI_AXES.forEach(({ key }) => {
    if (data.values && Object.prototype.hasOwnProperty.call(data.values, key)) {
      values[key] = clampInt0to5(data.values[key]);
    }
  });
  return {
    enabled: Boolean(data.enabled),
    notes: typeof data.notes === 'string' ? data.notes : base.notes,
    values,
  };
}

/** Modello da mostrare in scheda pubblica / anteprima (solo se abilitato). */
export function resolveSchemaGrazziniForDisplay(raw) {
  const merged = mergeSchemaGrazzini(raw);
  if (!merged.enabled) return null;
  return merged;
}
